/*@flow*/
/** @jsx jsx */
import { css, jsx } from '@emotion/core';
import { compose, type HOC, withStateHandlers } from 'recompose';
import Destroy from './Destroy';
import hideDialog from './hideDialog';

export type StatusT = 'Success' | 'Working' | 'Failed';
export type ProgressResponse = {
  status: StatusT,
  message: string,
  percent: number,
  errors: string[],
};

type InputPropsT = {|
  onSelectAll: Function,
  onClear: Function,
  allSelected: boolean,
  selection: string[],
  numRecords: number,
  onDestroy: Function,
  onDestroyProgress: (string) => Promise<ProgressResponse>,
|};
type EnhancedPropsT = {
  ...InputPropsT,
  update: Function,
  actionStarted: boolean,
  jobId: ?string,
  errors: string[],
};

const Enhance: HOC<EnhancedPropsT, InputPropsT> = compose(
  withStateHandlers(
    { actionStarted: false, jobId: undefined, errors: [] },
    { update: () => (s) => s }
  )
);

const Component = (props: EnhancedPropsT) => {
  const numSelected = props.selection.length;
  const realSelected = props.allSelected ? props.numRecords : numSelected;
  const canDestroy = realSelected > 0;

  const onDestroyConfirmed = () => {
    hideDialog();
    props
      .onDestroy()
      .then((res: { job_id: string }) => {
        if (res.job_id) {
          props.update({ jobId: res.job_id, actionStarted: true });
        }
      })
      .catch((e: { errors: string[] }) => {
        props.update({ errors: e.errors });
      });
  };

  return (
    <div css={css('padding: 5px 15px;')}>
      {realSelected} selected.{' '}
      {props.allSelected ? (
        <button
          css={css('text-decoration: underline;')}
          onClick={props.onClear}
        >
          Clear
        </button>
      ) : (
        <button
          css={css('text-decoration: underline;')}
          onClick={props.onSelectAll}
        >
          Select all
        </button>
      )}
      <Destroy
        allSelected={props.allSelected}
        actionStarted={props.actionStarted}
        canDestroy={canDestroy}
        jobId={props.jobId}
        onDestroyProgress={props.onDestroyProgress}
        onDestroyConfirmed={onDestroyConfirmed}
      />
    </div>
  );
};

export default Enhance(Component);
